import React, { FC, memo, useCallback, useMemo, useRef, useState } from "react";
import { cssSideTitleRow } from "@/components/Products";
import { COMPANIONS_TITLE, IMAGE_CONFIG } from "@/components/Products/constants";
import { ProductCategoriesTags } from "@/components/Products/parts/TagsCategories/Tags";
import { ProductsContainerPropsType } from "@/components/Products/Slider/types";
import { cssNavContainer, cssNavNext, cssNavPrev } from "@/components/Swiper/StyledSwiper";
import { TagsSizeVariant } from "@/components/Tags/constants";
import { Typography } from "@/components/ui/Typography/Typography";
import { useWindowSize } from "@/hooks/useWindowSize";
import { getBreakpointVal } from "@/styles/utils/Utils";
import { breakpoints } from "@/styles/utils/vars";
import { Button } from "@/ui/Button/Button";
import { ButtonGroup } from "@/ui/Button/StyledButton";
import { filterProductsByCategory } from "@/utils/common";
import { ProductsSlider } from "../../Slider";
const CompanionsContainer: FC<ProductsContainerPropsType> = memo(({
  products,
  ruleSort
}) => {
  const {
    width
  } = useWindowSize();
  const isMoreSm = width !== undefined && width > getBreakpointVal(breakpoints.sm);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);
  const productsItems = useMemo(() => selectedCategory === null ? products : filterProductsByCategory({
    products: products,
    category: selectedCategory
  }), [products, selectedCategory]);
  const onSelectHandle = useCallback((uuid: string | number | null) => {
    setSelectedCategory(!uuid ? null : `${uuid}`);
  }, []);
  if (!products.length) {
    return null;
  }
  return <ProductsSlider products={productsItems} ruleSort={ruleSort} slidesPerView={2} responsiveExtends={{
    [getBreakpointVal(breakpoints.md)]: {
      slidesPerView: 2
    },
    0: {
      slidesPerView: 1
    }
  }} title={{
    content: <div className={cssSideTitleRow}>
              <Typography variant={"h3"}>{COMPANIONS_TITLE}</Typography>
              <ButtonGroup className={cssNavContainer}>
                <Button variant={"arrow"} icon={"AngleLeft"} ref={prevRef} className={cssNavPrev} />
                <Button variant={"arrow"} icon={"AngleRight"} ref={nextRef} className={cssNavNext} />
              </ButtonGroup>
            </div>,
    leftPadding: isMoreSm
  }} productImageConfig={{
    width: IMAGE_CONFIG.responsive.size.width,
    height: IMAGE_CONFIG.responsive.size.height
  }} extendNavigation={{
    prevRef,
    nextRef,
    enabled: true
  }} childrenCenter={<ProductCategoriesTags products={products} onSelect={onSelectHandle} size={TagsSizeVariant.SMALL} />} />;
});
CompanionsContainer.displayName = "CompanionsContainer";
export { CompanionsContainer };